import { FormOption } from 'types';

export const searchOptions: FormOption[] = [
  { label: 'N.º do pedido', value: 'codes' },
  { label: 'Email do cliente', value: 'email' },
  { label: 'CPF', value: 'cpf' },
  { label: 'EAN', value: 'ean' },
];

export const returnSearchOptions: FormOption[] = [
  { label: 'N.º do pedido', value: 'codes' },
  { label: 'CPF', value: 'cpf' },
  { label: 'Nome Cliente', value: 'customerName' },
];

export const salesModes: FormOption[] = [
  { label: 'Retire na loja', value: 'PICK_UP_IN_STORE' },
  { label: 'Entrega pela loja', value: 'SHIPPING_FROM_STORE' },
];
